import Vue from "vue";
import VueRouter from "vue-router";

import App from "@/App.vue";
import Home from "@/views/Home.vue";
import DriverSchedule from "@/views/delivery/DriverSchedule.vue";
import ZoneDeliveryRate from "@/views/delivery/ZoneDeliveryRate.vue";
import SpecialZoneDeliveryRate from "@/views/delivery/SpecialZoneDeliveryRate.vue";
import DeliveryRate from "@/views/delivery/DeliveryRate.vue";
import UserLogin from "@/views/login/UserLogin.vue";
import NotFound from "@/views/common/NotFound.vue";
import Dashboard from "@/views/common/Dashboard.vue";
import LoginTransit from "@/views/login/LoginTransit.vue";
import ManualOrderFulfillment from "@/views/order/ManualOrderFulfillment.vue";
import CutOffTimeTable from "@/views/order/cutoff-time-table.vue";
import LatestOrderPulls from "@/views/order/LatestOrderPulls.vue";
import PassThrough from "@/views/common/PassThrough.vue";
import OrderReports from "@/views/reports/OrderReports.vue";
import OrderPullAutomation from "@/views/reports/OrderPullAutomation.vue";
import ReportsList from "@/views/reports/ReportsList.vue";
import RulesConfig from "@/views/reports/RulesConfig.vue";
import RulesList from "@/views/reports/RulesList.vue";
import SchedulesList from "@/views/reports/SchedulesList.vue";
import SchedulesConfig from "@/views/reports/SchedulesConfig.vue";
import QuickReports from "@/views/reports/QuickReports.vue";
import BulkPrePulls from "@/views/reports/BulkPrePulls.vue";
import PullSchedules from "@/views/reports/PullSchedules.vue";
import Sms from "@/views/sms/Sms.vue";
import TextSchedules from "@/views/sms/TextSchedules.vue";
import UnsubscribeList from "@/views/unsubscribe/UnsubscribeList.vue";
import UnsubscribeEmail from "@/views/unsubscribe/UnsubscribeEmail.vue";
import CustomerList from "@/views/unsubscribe/CustomerList.vue";
import Greets from "@/views/greets/Greets.vue";
import OpsLinks from "@/views/ops/OpsLinks.vue";
import OpsCreds from "@/views/ops/OpsCreds.vue";
import PostalCodeQuery from "@/views/ops/PostalCodeQuery.vue";
import LargeLabels from "@/views/exporter/LargeLabels.vue";
import LargeLabelsNew from "@/views/exporter/LargeLabelsNew.vue";
import CalliaExcelToPdf from "@/views/exporter/CalliaExcelToPdf.vue";
import CalliaWordToPdf from "@/views/exporter/CalliaWordToPdf.vue";
import CalliaGiftBox from "@/views/exporter/CalliaGiftBox.vue";
import ExporterProcessReport from "@/views/exporter/ExporterProcessReport.vue";
import Region from "@/views/region/RegionDashboard.vue";
import PostalCode from "@/views/postalcode/PostalCodeDashboard.vue";
import Town from "@/views/town/TownDashboard.vue";
import BulkOrder from "@/views/b2borderautomation/b2bordersubmission.vue";
import Zone from "@/views/zone/ZoneDashboard.vue";
import OnfleetDriversTaskToday from "@/views/driversmshub/onfleetDriversTaskToday.vue";
import { navigationGuard } from "./callia-auth0-authenticate";
import FailedOrder from "@/views/b2borderautomation/b2bfailedordersubmission.vue";
import DeliveryNotificationDashboard from "@/views/deliverynotification/DeliveryNotificationDashboard.vue";
import GreetBulk from "@/views/greets/CreateBulkOrder.vue";
import GreetList from "@/views/greets/GreetList.vue";
import GiftsetTemplateDashboard from "@/views/giftset-alert-template/GiftsetTemplateDashboard.vue";
import GiftSetsAlert from "@/views/giftsetsalert/GiftSetsAlertDashboard.vue";
import ReplacementOrderAutomation from "@/views/order/ReplacementOrderAutomation.vue";
import CheckoutAutomation from "@/views/order/CheckoutAutomation.vue";
import BulkOrderLinkCreator from "@/views/order/BulkOrderLinkCreator.vue";
import UpgradeAutomation from "@/views/order/UpgradeAutomation.vue";
import MassAdjustTags from "@/views/order/MassAdjustTags.vue";
import DeliveryWindowQuery from "@/views/order/DeliveryWindowQuery.vue";
import DatesClosed from "@/views/rules/DatesClosed.vue";
import ProductUploads from "@/views/products/ProductUploads.vue";
import DatesAvailable from "@/views/rules/DatesAvailable.vue";
import InventoryForecast from "@/views/inventory-forecast/inventory-forecast.vue";
import DevECSManage from "@/views/devCorner/devECSManage.vue";
import DeployMaintenanceSite from "@/views/devCorner/deployMaintenanceSite.vue";
import PasswordReset from "@/views/customer/customer-accounts/PasswordReset.vue";
import ConversationSummarizer from "@/views/AI/ConversationSummarizer.vue"

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  routes: [
    // { path: "/login", component: UserLogin },
    {
      path: "",
      component: LoginTransit,
      meta: {
        noAuth: true
      }
    },
    {
      path: "/login",
      component: UserLogin,
      meta: {
        noAuth: true
      }
    },
    { path: "/logout", redirect: "/" },
    // {
    //   path: "/transit",
    //   component: LoginTransit
    // },
    {
      path: "*",
      component: NotFound
    },
    {
      path: "/secure",
      component: Home,
      children: [
        {
          path: ":userId/dashboard",
          component: Dashboard
        },
        {
          path: "ai",
          component: PassThrough,
          children: [
            {
              path: "conversation-summarizer",
              component: ConversationSummarizer
            },
          ]
        },
        {
          path: "dev-corner",
          component: PassThrough,
          children: [
            {
              path: "dev-ecs-manage",
              component: DevECSManage
            },
            {
              path: "deploy-maintenance-site",
              component: DeployMaintenanceSite
            }
          ]
        },
        {
          path: "orders",
          component: PassThrough,
          children: [
            {
              path: "manual-fullfillment",
              component: ManualOrderFulfillment
            },
            {
              path: "cutoffs",
              component: CutOffTimeTable
            },
            {
              path: "bulkorder",
              component: BulkOrder
            },
            {
              path: "failedorder",
              component: FailedOrder
            },
            {
              path: "latest-order-pulls",
              component: LatestOrderPulls
            },
            {
              path: "replacement-order-automation",
              component: ReplacementOrderAutomation
            },
            {
              path: "checkout-automation",
              component: CheckoutAutomation
            },
            {
              path: "bulk-order-link-creator",
              component: BulkOrderLinkCreator
            },
            {
              path: "upgrade-automation",
              component: UpgradeAutomation
            },
            {
              path: "mass-adjust-tags",
              component: MassAdjustTags
            },
            {
              path: "delivery-window-query",
              component: DeliveryWindowQuery
            }
          ]
        },
        {
          path: "rules",
          component: PassThrough,
          children: [
            {
              path: "dates-closed",
              component: DatesClosed
            },
            {
              path: "dates-available",
              component: DatesAvailable
            }
          ]
        },
        {
          path: "ops",
          component: PassThrough,
          children: [
            {
              path: "links",
              component: OpsLinks
            },
            {
              path: "creds",
              component: OpsCreds
            },
            {
              path: "postal-code-query",
              component: PostalCodeQuery
            }
          ]
        },
        {
          path: "customer",
          component: PassThrough,
          children: [{ path: "password-reset", component: PasswordReset }]
        },
        {
          path: "schedule",
          component: PassThrough,
          children: [
            {
              path: "drivers",
              component: DriverSchedule
            }
          ]
        },
        {
          path: "reports",
          component: PassThrough,
          children: [
            {
              path: "order-reports",
              name: "OrderReports",
              component: OrderReports
            },
            {
              path: "reports-list",
              name: "ReportsList",
              component: ReportsList
            },
            {
              path: "pull-automation",
              name: "OrderPullAutomation",
              component: OrderPullAutomation
            },
            {
              path: "rules-config",
              name: "RulesConfig",
              component: RulesConfig
            },
            {
              path: "rules-list",
              name: "RulesList",
              component: RulesList
            },
            {
              path: "schedules-list",
              name: "SchedulesList",
              component: SchedulesList
            },
            {
              path: "schedules-config",
              name: "SchedulesConfig",
              component: SchedulesConfig
            },
            {
              path: "quick-reports",
              component: QuickReports
            },
            {
              path: "bulk-pre-pulls",
              component: BulkPrePulls
            },
            {
              path: "pull-schedules",
              component: PullSchedules
            },
            {
              path: "inventory-forecast",
              component: InventoryForecast
            }
          ]
        },
        {
          path: "sms",
          component: PassThrough,
          children: [
            {
              path: "history",
              component: Sms
            }
          ]
        },
        {
          path: "unsubscribe",
          component: PassThrough,
          children: [
            {
              path: "phone",
              component: UnsubscribeList
            },
            {
              path: "email",
              component: UnsubscribeEmail
            },
            {
              path: "customer-list",
              component: CustomerList
            },
            {
              path: "phone",
              component: UnsubscribeList
            },
            {
              path: "email",
              component: UnsubscribeEmail
            }
          ]
        },
        {
          path: "greets",
          component: PassThrough,
          children: [
            {
              path: "add-greets",
              component: Greets
            },
            {
              path: "bulk-greets",
              component: GreetBulk
            },
            {
              path: "greet-list",
              component: GreetList
            }
          ]
        },
        {
          path: "region",
          component: Region
        },
        {
          path: "postalcode",
          component: PostalCode
        },
        {
          path: "zone-delivery-rate",
          component: ZoneDeliveryRate
        },
        {
          path: "special-zone-delivery-rate",
          component: SpecialZoneDeliveryRate
        },
        {
          path: "delivery-rate",
          component: DeliveryRate
        },
        {
          path: "products",
          component: PassThrough,
          children: [
            {
              path: "product-uploads",
              component: ProductUploads
            }
          ]
        },
        {
          path: "exporter",
          component: PassThrough,
          children: [
            {
              path: "callia-excel-to-pdf",
              component: CalliaExcelToPdf
            },
            {
              path: "callia-gift-box",
              component: CalliaGiftBox
            },
            {
              path: "callia-word-to-pdf",
              component: CalliaWordToPdf
            },
            {
              path: "large-labels",
              component: LargeLabels
            },
            {
              path: "large-labels-new",
              component: LargeLabelsNew
            },
            {
              path: "export-process-report",
              component: ExporterProcessReport
            }
          ]
        },
        {
          path: "zone",
          component: Zone
        },
        {
          path: "mass-sms-hub",
          component: PassThrough,
          children: [
            {
              path: "onfleet-drivers-today",
              component: OnfleetDriversTaskToday
            }
          ]
        },

        {
          path: "town",
          component: Town
        },
        {
          path: "delivery-notification/SMS",
          component: DeliveryNotificationDashboard
        },
        {
          path: "giftset/template",
          component: GiftsetTemplateDashboard
        },
        /*{
            path: "giftsetsalert",
            component: PassThrough,
            children: [
                {
                    path: "giftsetsalert",
                    component: GiftSetsAlert
                },

            ]
        }*/
        {
          path: "giftset/alert",
          component: GiftSetsAlert
        },
        {
          path: "town",
          component: Town
        },
        {
          path: "delivery-notification/SMS",
          component: DeliveryNotificationDashboard
        },
        {
          path: "delivery-notification/schedules",
          component: TextSchedules
        }
      ]
    }
  ]
});
router.beforeEach(navigationGuard);
export default router;
